import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-line-loading',
  templateUrl: './line-loading.component.html',
  styleUrls: ['./line-loading.component.scss']
})
export class LineLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
